
export const nodesMock_v2 = [
    {
        "id" : 7,
        "name" : "Espanol",
        "description" : "",
        "xsiNodeId" : "8140046U10006",
        "nodeTypeId" : 2,
        "officeId" : 2,
        "extensionNumber" : "2295",
        "phoneNumber" : "957500280",
        "terminalType" : "",
        "emailWebex" : ""
    },
    {
        "id" : 8,
        "name" : "Frances",
        "description" : "",
        "xsiNodeId" : "8140046U10009",
        "nodeTypeId" : 2,
        "officeId" : 2,
        "extensionNumber" : "2292",
        "phoneNumber" : "957500910",
        "terminalType" : "",
        "emailWebex" : ""
    },
    {
        "id" : 9,
        "name" : "Desvio por prefijo",
        "description" : "",
        "xsiNodeId" : "8140046U10007",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2291",
        "phoneNumber" : "957509172",
        "terminalType" : "",
        "emailWebex" : ""
    },
    {
        "id" : 10,
        "name" : "Ingles",
        "description" : "",
        "xsiNodeId" : "8140046U10010",
        "nodeTypeId" : 2,
        "officeId" : 2,
        "extensionNumber" : "2293",
        "phoneNumber" : "957509274",
        "terminalType" : "",
        "emailWebex" : ""
    },
    {
        "id" : 11,
        "name" : "Bricoladores",
        "description" : "",
        "xsiNodeId" : "8140046U10005",
        "nodeTypeId" : 2,
        "officeId" : 2,
        "extensionNumber" : "2294",
        "phoneNumber" : "957514360",
        "terminalType" : "",
        "emailWebex" : ""
    },
    {
        "id" : 12,
        "name" : "Lucia Oteros",
        "description" : "",
        "xsiNodeId" : "8140046U10003",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2231",
        "phoneNumber" : "957544614",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "lucia.oteros@visobath.com"
    },
    {
        "id" : 13,
        "name" : "Robinson Zamanillo",
        "description" : "",
        "xsiNodeId" : "8140046U10004",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2233",
        "phoneNumber" : "957544615",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "rzamanillo@visobath.com"
    },
    {
        "id" : 14,
        "name" : "BUM",
        "description" : "",
        "xsiNodeId" : "8140046U10000",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2299",
        "phoneNumber" : "957622381",
        "terminalType" : "Aastra68xx",
        "emailWebex" : ""
    },
    {
        "id" : 15,
        "name" : "Centralita",
        "description" : "",
        "xsiNodeId" : "8140046U00002",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2101",
        "phoneNumber" : "957623367",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "pilarsanchez@visohome.com"
    },
    {
        "id" : 16,
        "name" : "Jesus Lumbreras",
        "description" : "",
        "xsiNodeId" : "8140046U00003",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2102",
        "phoneNumber" : "957623368",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "jlumbreras@visohome.com"
    },
    {
        "id" : 17,
        "name" : "Inma Rodriguez",
        "description" : "",
        "xsiNodeId" : "8140046U00004",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2108",
        "phoneNumber" : "957623369",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "inma.rodriguez@visohome.com"
    },
    {
        "id" : 18,
        "name" : "Carmen Romero",
        "description" : "",
        "xsiNodeId" : "8140046U00005",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2103",
        "phoneNumber" : "957623370",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "carmen.romero@visobath.com"
    },
    {
        "id" : 19,
        "name" : "Carolina Algar",
        "description" : "",
        "xsiNodeId" : "8140046U00006",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2232",
        "phoneNumber" : "957623371",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "carolina.algar@visohome.com"
    },
    {
        "id" : 20,
        "name" : "Paqui Corpas",
        "description" : "",
        "xsiNodeId" : "8140046U00007",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2134",
        "phoneNumber" : "957623372",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "pcorpas@visobath.com"
    },
    {
        "id" : 21,
        "name" : "Pepe Munoz",
        "description" : "",
        "xsiNodeId" : "8140046U00008",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2117",
        "phoneNumber" : "957623373",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "pepe.munoz@visohome.com"
    },
    {
        "id" : 22,
        "name" : "Ana Gomez",
        "description" : "",
        "xsiNodeId" : "8140046U00009",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2125",
        "phoneNumber" : "957623374",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "ana.gomez@visobath.com"
    },
    {
        "id" : 23,
        "name" : "Jose Carlos Castilla",
        "description" : "",
        "xsiNodeId" : "8140046U00010",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2229",
        "phoneNumber" : "957623375",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "josecarlos.castilla@visobath.com"
    },
    {
        "id" : 24,
        "name" : "Pilar Hurtado",
        "description" : "",
        "xsiNodeId" : "8140046U00011",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2230",
        "phoneNumber" : "957623376",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "phurtado@visobath.com"
    },
    {
        "id" : 25,
        "name" : "Lorena Nery",
        "description" : "",
        "xsiNodeId" : "8140046U00012",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2115",
        "phoneNumber" : "957623377",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "lorena.nery@visobath.com"
    },
    {
        "id" : 26,
        "name" : "Jennifer Porras",
        "description" : "",
        "xsiNodeId" : "8140046U00013",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2237",
        "phoneNumber" : "957623378",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "jennifer.porras@visobath.com"
    },
    {
        "id" : 27,
        "name" : "Araceli Plaza",
        "description" : "",
        "xsiNodeId" : "8140046U00014",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2127",
        "phoneNumber" : "957623379",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "araceliplaza@visobath.com"
    },
    {
        "id" : 28,
        "name" : "Rocio Jimenez",
        "description" : "desc 4",
        "xsiNodeId" : "8140046U00015",
        "nodeTypeId" : 1,
        "officeId" : 2,
        "extensionNumber" : "2119",
        "phoneNumber" : "957623380",
        "terminalType" : "Aastra68xx",
        "emailWebex" : "rocio.jimenez@visobath.com"
    }
];


export const userMock = {
    "companyId": 1,
    "lasAccessDateTime": "2022-08-09T11:02:50.295Z",
    "lasActionDateTime": "2022-08-09T11:02:50.295Z",
    "numLoginRetries": 0,
    "passwordChangeMandatory": 0,
    "passwordExpirationDateTime": "2022-08-09T11:02:50.295Z",
    "passwordResetToken": "string",
    "previousAccessDatetime": "2022-08-09T11:02:50.295Z",
    "roleId": 1,
    "userCreationDate": "2022-08-09T11:02:50.295Z",
    "userEmail": "email@prueba_1.com",
    "userId": 1,
    "userLocked": 0,
    "userLogin": "user_login_1",
    "userName": "user_name_1",
    "userPassword": "user_password_1",
    "userSession": "user_session_1"
};

export const usersMock = [
    {
        "firstName": "user_name_01",
        "lastName": "user_lastName_01",
        "userLogin": "user_login_01",
        "email": "email_user_01@mock.com",
        "locked": false,
        "failedLoginRetries": 0,
        "lastAccess": "2022-08-22T10:45:45.618Z",
        "previousAccess": "2022-08-22T10:45:45.618Z",
        "lastAction": "2022-08-22T10:45:45.618Z",
        "passwordChangeMandatory": false,
        "passwordExpiry": "2022-08-22T10:45:45.618Z",
        "roleId": 1,
        "companyId": 1
    },
    {
        "firstName": "user_name_02",
        "lastName": "user_lastName_02",
        "userLogin": "user_login_02",
        "email": "email_user_02@mock.com",
        "locked": true,
        "failedLoginRetries": 0,
        "lastAccess": "2022-08-22T10:45:45.618Z",
        "previousAccess": "2022-08-22T10:45:45.618Z",
        "lastAction": "2022-08-22T10:45:45.618Z",
        "passwordChangeMandatory": false,
        "passwordExpiry": "2022-08-22T10:45:45.618Z",
        "roleId": 2,
        "companyId": 2
    }
];

export const dataLoginMock = {
    authorities: [
        {
            roleId: 2,
            roleName: "Site admin"
        }
    ],
    expires: "2022-08-08T08:27:49.966Z",
    lastAccesDateTime: "2022-08-08T08:27:49.966Z",
    token: "token_test",
    typeAuth: "string",
    userName: "nombre_test"
};

export const companyMock = {
    "companyId": 12345,
    "companyName": "nombre_empresa_mock",
    "licenseTypeId": 5
};

export const companiesMock = [
    {
        "companyId": 1,
        "companyName": "company_name_01",
        "companyDesc": "company_desc_01",
        "companyEmail": "company_01@mock.com",
        "active": 0,
        "creation": "2022-08-22",
        "fsCode": "fsCode_01",
        "licenseExpiration": "2022-08-22",
        "licenseTypeId": 0,
        "xsiCompanyId": "xsiCompanyId_01",
        "xsiServiceType": "xsiServiceType_01"
    },
    {
        "companyId": 2,
        "companyName": "company_name_02",
        "companyDesc": "company_desc_02",
        "companyEmail": "company_02@mock.com",
        "active": 0,
        "creation": "2022-08-22",
        "fsCode": "fsCode_02",
        "licenseExpiration": "2022-08-22",
        "licenseTypeId": 0,
        "xsiCompanyId": "xsiCompanyId_02",
        "xsiServiceType": "xsiServiceType_02"
    },
    {
        "companyId": 3,
        "companyName": "company_name_03",
        "companyDesc": "company_desc_03",
        "companyEmail": "company_03@mock.com",
        "active": 0,
        "creation": "2022-08-22",
        "fsCode": "fsCode_03",
        "licenseExpiration": "2022-08-22",
        "licenseTypeId": 0,
        "xsiCompanyId": "xsiCompanyId_03",
        "xsiServiceType": "xsiServiceType_03"
    },
    {
        "companyId": 4,
        "companyName": "company_name_02",
        "companyDesc": "company_desc_04",
        "companyEmail": "company_04@mock.com",
        "active": 0,
        "creation": "2022-08-22",
        "fsCode": "fsCode_04",
        "licenseExpiration": "2022-08-22",
        "licenseTypeId": 0,
        "xsiCompanyId": "xsiCompanyId_04",
        "xsiServiceType": "xsiServiceType_04"
    },
    {
        "companyId": 5,
        "companyName": "company_name_05",
        "companyDesc": "company_desc_05",
        "companyEmail": "company_05@mock.com",
        "active": 0,
        "creation": "2022-08-22",
        "fsCode": "fsCode_05",
        "licenseExpiration": "2022-08-22",
        "licenseTypeId": 0,
        "xsiCompanyId": "xsiCompanyId_05",
        "xsiServiceType": "xsiServiceType_05"
    },
];

export const nodeTypeListMock = [
    {key: 'nodo_1', value: 1},
    {key: 'nodo_2', value: 2},
    {key: 'nodo_3', value: 3},
    {key: 'nodo_4', value: 4},
    {key: 'nodo_5', value: 5},
    {key: 'nodo_6', value: 6}
]

export const usersRolesListMock = [
    {key: 'rol_1', value: 1},
    {key: 'rol_2', value: 2},
    {key: 'rol_3', value: 3},
    {key: 'rol_4', value: 4},
    {key: 'rol_5', value: 5},
    {key: 'rol_6', value: 6},
    {key: 'rol_7', value: 7},
    {key: 'rol_8', value: 8},
    {key: 'rol_9', value: 9},
    {key: 'rol_10', value: 10}
]

export const licenceTypeListMock = [
    {key: 'licence_type_1', value: 1},
    {key: 'licence_type_2', value: 2},
    {key: 'licence_type_3', value: 3},
    {key: 'licence_type_4', value: 4},

]

export const xsiServiceTypeListMock = [
    {key: 'xsiService_1', value: 1},
    {key: 'xsiService_2', value: 2},
    {key: 'xsiService_3', value: 3},
    {key: 'xsiService_4', value: 4}
    
]
